// In-memory Google Drive OAuth token, shared by the assistant's Drive picker (reads and
// writes it) and the logout teardown (clears it). Cached so returning users are not sent
// through the account chooser on every open.
let cachedToken: { accessToken: string; expiresAt: number } | null = null;
const TOKEN_EXPIRY_BUFFER_MS = 60_000;

/** The cached access token while it is still valid beyond the expiry buffer, else null. */
export function getGoogleDriveToken(): string | null {
  if (!cachedToken || cachedToken.expiresAt <= Date.now() + TOKEN_EXPIRY_BUFFER_MS) return null;
  return cachedToken.accessToken;
}

export function setGoogleDriveToken(accessToken: string, expiresInSeconds: number): void {
  cachedToken = { accessToken, expiresAt: Date.now() + expiresInSeconds * 1000 };
}

/**
 * Clears the token. Called from the logout teardown so a later session in the same tab can
 * never reuse the previous user's Drive token.
 */
export function clearGoogleDriveTokenCache(): void {
  cachedToken = null;
}
